/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import BaseModal from 'src/common/components/Modal';
import {
	NEW_ORDER_INPUTS,
	formatOrders,
	filterOrdersByIssue,
	getIssues,
} from '../utils/list_data';
import UtilInputs from 'src/common/components/UtilInputs';
import { orderOfTheDayAPI } from 'src/api/modules/orderOfTheDay';
import notice from 'src/common/components/Notice';

const INIT_VALUES = {
	nombreTema: '',
	duracion: '',
	dentroDe: '',
};

const AddNewOrder = ({
	issue,
	isOpen,
	onClose,
	user,
	session,
	approval,
	generalBusiness,
	forKnowledge,
	opinions,
	addMatters,
	setApproval,
	setGeneralBusiness,
	setForKnowledge,
	setAddMatters,
	setOpinions,
	isAuxiliar,
}) => {
	const [inputValues, setInputValues] = useState(INIT_VALUES);
	const [lastOrderByIssue, setLastOrderByIssues] = useState(0);
	const [options, setOptions] = useState([]);
	const [isLoadingResponse, setIsLoadingResponse] = useState(false);

	const getOrder = (orders) => {
		let ordersFlag = [];

		orders.forEach((item) => {
			ordersFlag.push({
				value: item.id,
				text: `${item.numeracion} ${item.nombreTema}`,
			});
			if (item.hijos.length > 0) {
				ordersFlag = ordersFlag.concat(getOrder(item.hijos));
			}
		});
		return ordersFlag;
	};

	const fetchOrderOfTheDay = React.useCallback(() => {
		orderOfTheDayAPI
			.getOrderOfTheDay(session)
			.then((response) => {
				if (response && response.length > 0) {
					let ordersItems = getOrder(response);
					setOptions([...(ordersItems || [])]);
				}
			})
			.catch((e) => {
				notice(
					'Algo ha salido mal al cargar las ordenes del día, intente de nuevo'
				);
			});
	}, []);

	useEffect(() => {
		fetchOrderOfTheDay();
	}, [fetchOrderOfTheDay]);

	const getLastOrderByIssue = useCallback(() => {
		const lastOrder =
			issue === 'Para aprobación'
				? approval[approval.length - 1]?.order
				: issue === 'Para conocimiento'
					? forKnowledge[forKnowledge.length - 1]?.order
					: generalBusiness[generalBusiness.length - 1]?.order;
		return lastOrder;
	}, [issue, approval, forKnowledge, generalBusiness]);

	useEffect(() => {
		setLastOrderByIssues(getLastOrderByIssue());
	}, [getLastOrderByIssue]);

	const getOrderFather = (order, idFather) => {
		let orderFather = null;

		order.forEach((item) => {
			if (item.id === idFather) {
				orderFather = item;
				return;
			}
			if (item.subItems.length > 0) {
				const subItems = getOrderFather(item.subItems, idFather);
				if (subItems !== null) {
					orderFather = subItems;
					return;
				}
			}
		});
		return orderFather;
	};
	const getNumeration = (type) => {
		let numeration = 0;

		if (type === 'AD') {
			numeration = addMatters.length + 1;
		}
		if (type === 'PA') {
			numeration = approval.length + 1;
			numeration = numeration + addMatters.length;
		}
		if (type === 'DO') {
			numeration = opinions.length + 1;
			numeration = numeration + approval.length + addMatters.length;
		}
		if (type === 'PC') {
			numeration = forKnowledge.length + 1;
			numeration =
				numeration + approval.length + addMatters.length + opinions.length;
		}
		if (type === 'AC') {
			numeration = generalBusiness.length + 1;
			numeration =
				numeration +
				forKnowledge.length +
				approval.length +
				addMatters.length +
				opinions.length;
		}

		return numeration;
	};

	const getNumerationAuxiliar = (type) => {
		let numeration = 0;

		if (type === 'AD') {
			numeration = addMatters.length + 1;
		}
		if (type === 'PA') {
			numeration = approval.length + 1;
			numeration = numeration + addMatters.length;
		}

		if (type === 'DO') {
			numeration = opinions.length + 1;
			numeration = numeration + approval.length + addMatters.length;
		}

		if (type === 'PC') {
			numeration = forKnowledge.length + 1;
			numeration =
				numeration + approval.length + addMatters.length + opinions.length;
		}

		if (type === 'AC') {
			numeration = generalBusiness.length + 1;
			numeration =
				numeration +
				opinions.length +
				approval.length +
				forKnowledge.length +
				addMatters.length;
		}

		return numeration;
	};

	const createNewOrderOfTheDay = () => {
		const asunto = getIssues(issue);
		const orden = [
			...approval,
			...forKnowledge,
			...generalBusiness,
			...addMatters,
			...opinions,
		];

		let orderBranch = null;

		if (inputValues.dentroDe !== '') {
			//const orderFather = orden.find((o) => o.id === inputValues.dentroDe).order;

			const father = getOrderFather(orden, inputValues.dentroDe);
			const orderFather = father.order;

			const lastBranch = father.subItems.length + 1;
			orderBranch = `${orderFather}.${lastBranch}`;
		} else {
			isAuxiliar === true
				? (orderBranch = getNumerationAuxiliar(asunto))
				: (orderBranch = getNumeration(asunto));
		}

		const data = {
			numeracion:
				orderBranch !== null
					? orderBranch
					: lastOrderByIssue === 0 || lastOrderByIssue === undefined
						? orden.length + 1
						: +lastOrderByIssue + 1,
			nombreTema: inputValues.nombreTema,
			dentroDe: inputValues.dentroDe === '' ? null : inputValues.dentroDe,
			asunto,
			estatus: 'A', // Pendiente de validación
			usuarioId: user,
			sesionId: session,
		};

		setIsLoadingResponse(true);

		orderOfTheDayAPI
			.post(data)
			.then((response) => {
				setApproval(formatOrders(filterOrdersByIssue(response, 'PA')));
				setForKnowledge(formatOrders(filterOrdersByIssue(response, 'PC')));
				setGeneralBusiness(formatOrders(filterOrdersByIssue(response, 'AC')));
				setAddMatters(formatOrders(filterOrdersByIssue(response, 'AD')));
				setOpinions(formatOrders(filterOrdersByIssue(response, 'DO')));
				setInputValues(INIT_VALUES);
				notice('Nueva Orden del Día Creada', 'success');
			})
			.catch((e) => {
				notice('Algo ha salido mal, intente otra vez', 'warning');
			})
			.finally((e) => {
				setIsLoadingResponse(false);
				onClose(false);
			});
	};

	return (
		<BaseModal
			open={isOpen}
			onClose={onClose}
			onCancel={onClose}
			mainText={`Nueva Orden del Día`}
			onConfirm={createNewOrderOfTheDay}
			confirmLabel={'Guardar'}
			disableOnConfirm={isLoadingResponse}
			maxWidth="lg"
		>
			<UtilInputs
				formValues={inputValues}
				onValuesChange={(e) =>
					setInputValues({ ...inputValues, [e.target.name]: e.target.value })
				}
				inputValues={NEW_ORDER_INPUTS(options)}
			/>
		</BaseModal>
	);
};

export default AddNewOrder;
